import classNames from "classnames";
import { Icon } from "PFComponents/icon";

import css from "./chat_subheader.module.scss";

type ChatSubheaderProps = {
  handleClose?: VoidFunction;
  title?: React.ReactNode;
  center?: boolean;
  children?: React.ReactNode;
};

export const ChatSubheader = ({ handleClose, title, center, children }: ChatSubheaderProps) => (
  <div className={css.root} data-qa-id="chat-subheader">
    {handleClose && (
      // eslint-disable-next-line max-len
      // eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
      <a onClick={handleClose} className={css.back} data-qa-id="chat-window-button-back">
        <Icon name="caret-left" size="sm" />
      </a>
    )}
    {(title || children) && (
      <h3 className={classNames(css.title, { [css.center]: center })}>
        {title}
        {children}
      </h3>
    )}
  </div>
);
